import React from 'react';
import s from './Modal.module.css';
import cs from 'classnames';

function ModalLong({ children }: { children: React.ReactNode }) {
    const containerClassnames = cs(s.contents, 'py-4 px-6');
    return (
        <div className="fixed inset-0 overflow-y-auto">
            <div className={s.modal}>
                <span
                    className="hidden sm:inline-block sm:align-middle sm:h-screen"
                    aria-hidden="true"
                >
                    &#8203;
                </span>
                <div className={containerClassnames}>{children}</div>
            </div>
        </div>
    );
}

function Header({ children }: { children: React.ReactNode }) {
    return (
        <div className="w-full">
            <div className="w-full">{children}</div>
        </div>
    );
}

function BodyContainer({ children }: { children: React.ReactNode }) {
    return <div className="w-full py-4">{children}</div>;
}

function ButtonContainer({ children }: { children: React.ReactNode }) {
    return <div className="w-full">{children}</div>;
}

ModalLong.Header = Header;
ModalLong.Body = BodyContainer;
ModalLong.Footer = ButtonContainer;

export { ModalLong };
